// imports
import React from 'react';
import { IMAGE } from '../../../assets';

// interfaces / types / consts
interface Props { placeholderImg: string; title?: string; body?: string }

// exports
export default function Empty(props: Props): JSX.Element {
  const { placeholderImg, title, body } = props;
  return (
    <>
      <div className="dv-title">
        <img src={IMAGE.HERO_TITLE_MOTIF} alt="Left Motif" />
        <span>{title}</span>
        <img className="right-motif" src={IMAGE.HERO_TITLE_MOTIF} alt="Right Motif" />
      </div>
      <div className="dv-image-container">
        <div className="dv-avatar">
          <img className="frame" src={IMAGE.AVATAR_FRAME} alt="avatar_frame" />
          <img className="avatar empty" src={placeholderImg} alt="hero" />
        </div>
      </div>
      <div className="dv-details"><p>{body}</p></div>
    </>
  );
}

// default props
Empty.defaultProps = { body: '', title: '' };
